import React from "react";
export default class SVG extends React.Component {
  render() {
    return <svg baseProfile="tiny" xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" {...this.props}><path fill="#fff" d="M36 3.48s-1.405 2.275-3.68 3.814c.468 10.438-7.16 22.015-21.01 22.015C4.415 29.31 0 25.962 0 25.962s5.42 1.137 10.907-3.01c-5.554-.336-6.892-5.154-6.892-5.154s1.54.4 3.346-.135c-6.222-1.54-5.955-7.36-5.955-7.36s1.54.937 3.346.937c-5.62-4.35-2.274-9.904-2.274-9.904S7.56 8.498 17.732 9.1c-1.472-8.096 7.83-11.843 12.58-6.758 2.476-.4 4.75-1.807 4.75-1.807s-.802 2.744-3.278 4.082C33.792 4.483 36 3.48 36 3.48z" /></svg>;
  }

}


// WEBPACK FOOTER //
// ./src/assets/icons/twitter.svg